// 地图面类型（surfaceBase/list 返回的 surfaceType）
export enum SurfaceType {
    AREA = 'AREA', // 区域
    SURFACE = 'SURFACE', // 商圈板块
    NEW_HOUSE = 'NEW_HOUSE', // 新房
    SECOND_HAND_HOUSE = 'SECOND_HAND_HOUSE', // 二手房
    SCHOOL = 'SCHOOL', // 学校
    SUBWAY = 'SUBWAY', // 地铁
    GOVERNMENT = 'GOVERNMENT', // 政府机构
    BUSINESS = 'BUSINESS', // 商业
    PARK = 'PARK', // 公园景区
    HOSPITAL = 'HOSPITAL', // 医院
    COMPANY = 'COMPANY', // 公司企业
    HOUSE = 'HOUSE', // 土拍
    DISADVANTAGE = 'DISADVANTAGE', // 不利因素
    RELOCATION_HOUSE = 'RELOCATION_HOUSE', // 拆迁
    OTHER_TYPE = 'OTHER_TYPE', // 其他
    PUBLICFACILITIES = 'PUBLICFACILITIES', // 公共配套（归一化索引时跳过）
}

// 配置归属类型（surfaceBase/list 返回的 useType）
export enum SurfaceUseType {
    USER = 'USER', // 用户配置
}

// 渲染样式类型（surfaceBase/list 返回的 styleType）
export enum SurfaceStyleType {
    BUILDING = 'BUILDING', // 建筑 / 项目类样式
    PUBLICFACILITIES = 'PUBLICFACILITIES', // 公共配套类样式
}

// 主题（surfaceBase/list 返回的 theme）
export enum SurfaceTheme {
    DEFAULT = 1, // 默认主题
}

// 生活配套显隐（surfaceBase/list 返回的 livingDisplay）
export enum SurfaceLivingDisplay {
    SHOW = 1, // 显示
}

// GET /api/mydraw/surfaceBase/list - 地图渲染配置项（唯一地图设置数据来源）
export interface SurfaceBaseItem {
    searchValue: string | null;
    createBy: string;
    createTime: string;
    updateBy: string;
    updateTime: string;
    remark: string | null;
    params: Record<string, unknown>;
    id: string;
    useId: string;
    useType: SurfaceUseType;
    name: string; // 展示名称，如「区域」「新房」「地铁」
    mapId: string | null;
    surfaceType: SurfaceType;
    borderColor: string; // 边框颜色
    borderWidth: number; // 边框宽度
    fillColor: string; // 填充颜色
    fontSize: number; // 标签字号
    fontColor: string; // 标签文字颜色
    titleBgColor: string; // 标题背景色
    titleBgHeight: number; // 标题背景高度
    transparency: string; // 透明度（0-100 字符串）
    flickerFrequency: number; // 闪烁频率
    apertureRadius: number; // 光晕半径
    strokeSize: number; // 描边大小
    drawMapId: string | null; // 关联绘制地图 ID
    areaId: string | null;
    minZoomLevel: number; // 面 / 图层整体可见 zoom 下限（桌面）
    maxZoomLevel: number; // 面 / 图层整体可见 zoom 上限（桌面）
    padMinZoomLevel: number; // 面 / 图层整体可见 zoom 下限（平板）
    padMaxZoomLevel: number; // 面 / 图层整体可见 zoom 上限（平板）
    labelMinZoomLevel: number; // 标签可见 zoom 下限
    labelMaxZoomLevel: number; // 标签可见 zoom 上限
    userName: string | null;
    loginName: string | null;
    sortNum: string; // 排序序号
    styleType: SurfaceStyleType;
    modelMinZoomLevel: number; // 模型可见 zoom 下限
    modelMaxZoomLevel: number; // 模型可见 zoom 上限
    theme: SurfaceTheme;
    livingDisplay: SurfaceLivingDisplay;
}

export type SurfaceBaseList = SurfaceBaseItem[];

// 按 surfaceType 索引的配置表，由接口列表归一化得到，已排除 PUBLICFACILITIES
export type SurfaceBaseByType = Partial<Record<SurfaceType, SurfaceBaseItem>>;

// 层级类 surfaceType（AREA / SURFACE / SUBWAY）
export type LayerSurfaceType = SurfaceType.AREA | SurfaceType.SURFACE | SurfaceType.SUBWAY;

// lite 控规 pipeline 启用的项目 surfaceType
export type ProjectSurfaceType = SurfaceType.NEW_HOUSE | SurfaceType.SECOND_HAND_HOUSE | SurfaceType.SCHOOL;

// zoom 读取端：桌面 / 平板
export type SurfaceZoomDevice = 'desktop' | 'pad';

export interface SurfaceZoomRange {
    minZoom: number;
    maxZoom: number;
}
